import * as $ from 'jquery';
import * as ko from 'knockout';

import { KoGoogleMap } from 'Content/ts/Models/Shared/GoogleMapsModels';

export interface GoogleMapsVMParams
{
    googleMap: KoGoogleMap
}

export default class GoogleMapsVM {
    api: string;
    googleMapModel: KoGoogleMap;

    constructor(params: GoogleMapsVMParams) {
        var functionTag = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 10);

        this.googleMapModel = params.googleMap;
        this.api = 'https://maps.googleapis.com/maps/api/js?key={0}&callback={1}'
            .replace("{0}", this.googleMapModel.ApiKey())
            .replace("{1}", functionTag);


        var element = document.getElementById('googleMap');
        $(element)
            .append('<script type="text/javascript" src="' + this.api + '" async="true"></script>');
         
        (window as any)[functionTag] = this.initialiseMap.bind(this);
    }

    initialiseMap() {
        var position = new google.maps.LatLng(this.googleMapModel.Latitude(), this.googleMapModel.Longitude());

        var map = new google.maps.Map(document.getElementById('googleMap'), {
            center: position,
            zoom: this.googleMapModel.Zoom()
        });

        if (this.googleMapModel.MarkerInfo() != null && this.googleMapModel.MarkerInfo().length > 0) {
            var infowindow = new google.maps.InfoWindow({
                content: this.googleMapModel.MarkerInfo()
            });
        }

        var marker = new google.maps.Marker({
            position: position,
            map: map
        });

        marker.addListener('click', function () {
            infowindow.open(map, marker);
        });
    }
}

ko.components.unregister('google-maps');
ko.components.register('google-maps', {
    viewModel: GoogleMapsVM,
    template: { require: 'text!/Themes/Default/Content/ts/Shared/GoogleMaps/google-maps.html' }
});